import { useEffect } from 'react';
// IMPORTANT: Update this import path to point to your actual firebase initialization file
import { db } from './useFirebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const useAnalytics = (pagePath) => {
  useEffect(() => {
    // 1. Check for UTM source in the URL (moved outside so the trackingKey can use it)
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('utm_source');

    // Fallback: If UTM is stripped by FB/WhatsApp wrappers, check the referrer!
    if (!source) {
      const referrer = document.referrer.toLowerCase();
      if (referrer.includes('whatsapp')) source = 'whatsapp';
      else if (referrer.includes('facebook') || referrer.includes('fb.com')) source = 'facebook';
      else if (referrer.includes('t.co') || referrer.includes('twitter')) source = 'twitter';
      else source = 'direct';
    }

    const trackView = async () => {
      try {
        // 2. Check if the user agent is an actual search engine crawler
        const userAgent = navigator.userAgent.toLowerCase();
        const isBot = /bot|crawler|spider|crawling/i.test(userAgent);
        
        if (isBot) {
          console.log("Bot detected, skipping analytics.");
          return; // Don't record this view
        }

        // Detect if the user is on a mobile device or desktop
        const device = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent) ? 'Mobile' : 'Desktop';

        const isAdmin = localStorage.getItem('idia_admin') === 'true';

        // Generate or retrieve a completely anonymous unique visitor ID
        let visitorId = localStorage.getItem('idia_visitor_id');
        if (!visitorId) {
          // Use modern crypto API if available, otherwise fallback to random string
          visitorId = (crypto && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
          localStorage.setItem('idia_visitor_id', visitorId);
        }

        // 3. Fetch user location based on IP with redundant fallback
        let locationData = { country_name: 'Unknown', city: 'Unknown' };
        try {
          const res = await fetch('https://ipapi.co/json/');
          if (res.ok) {
            locationData = await res.json();
          } else {
            // Fallback: Try ip-api.com if ipapi.co rate limits
            const resFallback = await fetch('https://ip-api.com/json/');
            if (resFallback.ok) {
              const dataFallback = await resFallback.json();
              locationData = {
                country_name: dataFallback.country || 'Unknown',
                city: dataFallback.city || 'Unknown'
              };
            }
          }
        } catch (err) {
          try {
            const resFallback = await fetch('https://ip-api.com/json/');
            if (resFallback.ok) {
              const dataFallback = await resFallback.json();
              locationData = {
                country_name: dataFallback.country || 'Unknown',
                city: dataFallback.city || 'Unknown'
              };
            }
          } catch (nestedErr) {
            console.error("Could not fetch location from primary or secondary provider", nestedErr);
          }
        }

        // 4. Save the data to Firebase Firestore
        await addDoc(collection(db, 'page_views'), {
          // Use the exact path provided, or grab the URL and any parameters like ?p=123
          path: pagePath || (window.location.pathname + window.location.search),
          source: source,
          device: device,
          country: locationData.country_name,
          city: locationData.city,
          role: isAdmin ? 'admin' : 'visitor',
          visitorId: visitorId,
          timestamp: serverTimestamp(),
        });

      } catch (error) {
        console.error("Error recording analytics:", error);
      }
    };

    // Prevent duplicate tracking if the user just refreshes the page
    const trackingKey = `tracked_${pagePath || window.location.pathname}_${source}`;
    const tracked = sessionStorage.getItem(trackingKey);
    if (!tracked) {
      trackView();
      sessionStorage.setItem(trackingKey, 'true');
    }
  }, [pagePath]);
};